import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Faq.css';
import API_URL from '../../api/ExamCalendarApi';

const FAQComponent = () => {
  const [faqs, setFaqs] = useState([]);
  const [form, setForm] = useState({ question: '', answer: '', id: null });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Fetch all FAQs on component mount
  useEffect(() => {
    fetchFaqs();
  }, []);

  // Fetch FAQs from the API
  const fetchFaqs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/faqs/all-faqs`);
      setFaqs(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch FAQs');
      setLoading(false);
    }
  };

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // Submit new FAQ or update existing one
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.question || !form.answer) {
      setError('Both question and answer are required.');
      return;
    }
    try {
      setError('');
      setLoading(true);

      if (isEditing) {
        // Update existing FAQ
        await axios.put(`${API_URL}/faqs/update-faq/${form.id}`, {
          question: form.question,
          answer: form.answer,
        });
      } else {
        // Create new FAQ
        await axios.post(`${API_URL}/faqs/create-faq`, {
          question: form.question,
          answer: form.answer,
        });
      }

      setForm({ question: '', answer: '', id: null });
      setIsEditing(false);
      fetchFaqs(); // Refresh FAQ list
      setLoading(false);
    } catch (err) {
      setError('Failed to submit FAQ');
      setLoading(false);
    }
  };

  // Edit an FAQ
  const handleEdit = (faq) => {
    setForm({ question: faq.question, answer: faq.answer, id: faq._id });
    setIsEditing(true);
    window.scrollTo(0, 0);  // Scroll to top to bring form into view
  };

  // Delete an FAQ
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await axios.delete(`${API_URL}/faqs/delete-faq/${id}`);
      fetchFaqs(); // Refresh FAQ list
      setLoading(false);
    } catch (err) {
      setError('Failed to delete FAQ');
      setLoading(false);
    }
  };

  // Clear form
  const clearForm = () => {
    setForm({ question: '', answer: '', id: null });
    setIsEditing(false);
  };

  return (
    <div className='admin-faq-container'>
      <div className='admin-faq-section'>
        <div className="admin-faq-component">
          <h2 className="admin-faq-heading">FAQ Management</h2>
          {error && <p className="admin-faq-alert admin-faq-alert-danger">{error}</p>}

          {/* Form */}
          <form onSubmit={handleSubmit} className="admin-faq-form">
            <div className="admin-faq-form-group">
              <label className="admin-faq-form-label">Question:</label>
              <input
                type="text"
                name="question"
                value={form.question}  // Value linked to form state
                onChange={handleInputChange}
                className="admin-faq-form-control"
                placeholder="Enter your question"
              />
            </div>
            <div className="admin-faq-form-group">
              <label className="admin-faq-form-label">Answer:</label>
              <textarea
                name="answer"
                value={form.answer}  // Value linked to form state
                onChange={handleInputChange}
                className="admin-faq-form-control"
                placeholder="Enter the answer"
              />
            </div>
            <button type="submit" className="admin-faq-btn-primary">
              {isEditing ? 'Update' : 'Create'} FAQ
            </button>
            {isEditing && (
              <button
                type="button"
                className="admin-faq-btn-secondary"
                onClick={clearForm}
              >
                Cancel
              </button>
            )}
          </form>

          {/* Loading indicator */}
          {loading && <p>Loading...</p>}

          {/* FAQs List */}
          <div>
            <h3 className="admin-faq-subheading">All FAQs</h3>
            <ul className="admin-faq-list">
              {faqs.map((faq) => (
                <li key={faq._id} className="admin-faq-list-item">
                  <strong>Q:</strong> {faq.question} <br />
                  <strong>A:</strong> {faq.answer}
                  <br />
                  <div className="admin-faq-actions">
                    <button
                      className="admin-faq-btn-warning"
                      onClick={() => handleEdit(faq)}
                    >
                      Edit
                    </button>
                    <button
                      className="admin-faq-btn-danger"
                      onClick={() => handleDelete(faq._id)}
                    >
                      Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQComponent;
